import apiClient from './apiClient';

export const mapQuestionFromApi = (q, index = 0) => ({
  id: q._id ?? q.id ?? `bq-${index}`,
  question: q.question ?? '',
  options: Array.isArray(q.options) ? q.options : [],
  correct: typeof q.correct === 'number' ? q.correct : 0,
});

export const getBasicQuizQuestions = async () => {
  const { data } = await apiClient.get('/api/basic-quiz');
  if (!Array.isArray(data)) return [];
  return data.map((q, i) => mapQuestionFromApi(q, i));
};

export const saveBasicQuizQuestions = async (items) => {
  const payload = (items || []).map((q) => ({
    question: q.question ?? '',
    options: Array.isArray(q.options) ? q.options : [],
    correct: typeof q.correct === 'number' ? q.correct : 0,
  }));
  const { data } = await apiClient.put('/api/basic-quiz', payload);
  if (!Array.isArray(data)) return [];
  return data.map((q, i) => mapQuestionFromApi(q, i));
};

